export function detectPlatform(): "apple" | "google" | null {
  if (typeof navigator === "undefined") return null
  const ua = navigator.userAgent.toLowerCase()
  if (/iphone|ipad|ipod/.test(ua)) return "apple"
  if (/android/.test(ua)) return "google"
  return null
}

export function getCsrfToken(): string {
  if (typeof document === "undefined") return ""
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ?? ""
  )
}
